module.exports = __webpack_public_path__ + "static/media/envelope-upload-alt.313a1564.svg";